/**
 *
 * Special Squeeze Page
 * Javascript Magic to create urgency to help drive sales.
 *
 * Author: Ephraim Sng / Kangarang
 * Website: www.sngenterprises.com
 *
 * Sound used from notificationsounds.com under Creative Commons Attribution 4.0 International: https://notificationsounds.com/sound-effects/microbounce-65
 **/

/* jQuery Cookie */
!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if(i=e({path:"/"},t.defaults,i),"number"==typeof i.expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}i.expires=i.expires?i.expires.toUTCString():"";try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(e){}r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)),n=n.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),n=n.replace(/[\(\)]/g,escape);var f="";for(var s in i)i[s]&&(f+="; "+s,i[s]!==!0&&(f+="="+i[s]));return document.cookie=n+"="+r+f}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],d=0;d<p.length;d++){var u=p[d].split("="),l=u.slice(1).join("=");'"'===l.charAt(0)&&(l=l.slice(1,-1));try{var g=u[0].replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent);if(l=o.read?o.read(l,g):o(l,g)||l.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent),this.json)try{l=JSON.parse(l)}catch(e){}if(n===g){c=l;break}n||(c[g]=l)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}return n(function(){})});
//sourceMappingURL=
//js.cookie.min.js.map


/**
 * The Final Countdown for jQuery v2.2.0 (http://hilios.github.io/jQuery.countdown/)
 * Copyright (c) 2016 Edson Hilios
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
!function(a) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], a) : a(jQuery)
}(function(a) {
    "use strict";

    function b(a) {
        if (a instanceof Date) return a;
        if (String(a).match(g)) return String(a).match(/^[0-9]*$/) && (a = Number(a)), String(a).match(/\-/) && (a = String(a).replace(/\-/g, "/")), new Date(a);
        throw new Error("Couldn't cast `" + a + "` to a date object.")
    }

    function c(a) {
        var b = a.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
        return new RegExp(b)
    }

    function d(a) {
        return function(b) {
            var d = b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
            if (d)
                for (var f = 0, g = d.length; f < g; ++f) {
                    var h = d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
                        j = c(h[0]),
                        k = h[1] || "",
                        l = h[3] || "",
                        m = null;
                    h = h[2], i.hasOwnProperty(h) && (m = i[h], m = Number(a[m])), null !== m && ("!" === k && (m = e(l, m)), "" === k && m < 10 && (m = "0" + m.toString()), b = b.replace(j, m.toString()))
                }
            return b = b.replace(/%%/, "%")
        }
    }

    function e(a, b) {
        var c = "s",
            d = "";
        return a && (a = a.replace(/(:|;|\s)/gi, "").split(/\,/), 1 === a.length ? c = a[0] : (d = a[0], c = a[1])), Math.abs(b) > 1 ? c : d
    }
    var f = [],
        g = [],
        h = {
            precision: 1000, //this is seconds. Change to 10 for milliseconds
            elapse: !1,
            defer: !1
        };
    g.push(/^[0-9]*$/.source), g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source), g = new RegExp(g.join("|"));
    var i = {
            Y: "years",
            m: "months",
            n: "daysToMonth",
            d: "daysToWeek",
            w: "weeks",
            W: "weeksToMonth",
            H: "hours",
            M: "minutes",
            S: "seconds",
            f: "milliseconds",
            D: "totalDays",
            I: "totalHours",
            N: "totalMinutes",
            T: "totalSeconds"
        },
        j = function(b, c, d) {
            this.el = b, this.$el = a(b), this.interval = null, this.offset = {}, this.options = a.extend({}, h), this.firstTick = !0, this.instanceNumber = f.length, f.push(this), this.$el.data("countdown-instance", this.instanceNumber), d && ("function" == typeof d ? (this.$el.on("update.countdown", d), this.$el.on("stoped.countdown", d), this.$el.on("finish.countdown", d)) : this.options = a.extend({}, h, d)), this.setFinalDate(c), this.options.defer === !1 && this.start()
        };
    a.extend(j.prototype, {
        start: function() {
            null !== this.interval && clearInterval(this.interval);
            var a = this;
            this.update(), this.interval = setInterval(function() {
                a.update.call(a)
            }, this.options.precision)
        },
        stop: function() {
            clearInterval(this.interval), this.interval = null, this.dispatchEvent("stoped")
        },
        toggle: function() {
            this.interval ? this.stop() : this.start()
        },
        pause: function() {
            this.stop()
        },
        resume: function() {
            this.start()
        },
        remove: function() {
            this.stop.call(this), f[this.instanceNumber] = null, delete this.$el.data().countdownInstance
        },
        setFinalDate: function(a) {
            this.finalDate = b(a)
        },
        update: function() {
            if (0 === this.$el.closest("html").length) return void this.remove();
            var a, b = new Date;
            return a = this.finalDate.getTime() - b.getTime(), a = Math.ceil(a / 1e1), a = !this.options.elapse && a < 0 ? 0 : Math.abs(a), this.totalSecsLeft === a || this.firstTick ? void(this.firstTick = !1) : (this.totalSecsLeft = a, this.elapsed = b >= this.finalDate, this.offset = {
                milliseconds: this.totalSecsLeft % 100,
                seconds: Math.floor(this.totalSecsLeft / 100) % 60,
                minutes: Math.floor(this.totalSecsLeft / 100 / 60 ) % 60,
                hours: Math.floor(this.totalSecsLeft / 100 / 60 / 60) % 24,
                days: Math.floor(this.totalSecsLeft / 100 / 60 / 60 / 24) % 7,
                daysToWeek: Math.floor(this.totalSecsLeft / 100 / 60 / 60 / 24) % 7,
                daysToMonth: Math.floor(this.totalSecsLeft / 100 / 60 / 60 / 24 % 30.4368),
                weeks: Math.floor(this.totalSecsLeft / 100 / 60 / 60 / 24 / 7),
                weeksToMonth: Math.floor(this.totalSecsLeft  / 100 / 60 / 60 / 24 / 7) % 4,
                months: Math.floor(this.totalSecsLeft / 100 / 60 / 60 / 24 / 30.4368),
                years: Math.abs(this.finalDate.getFullYear() - b.getFullYear()),
                totalDays: Math.floor(this.totalSecsLeft / 100 / 60 / 60 / 24),
                totalHours: Math.floor(this.totalSecsLeft / 100 / 60 / 60),
                totalMinutes: Math.floor(this.totalSecsLeft / 100 / 60),
                totalSeconds: this.totalSecsLeft
            }, void(this.options.elapse || 0 !== this.totalSecsLeft ? this.dispatchEvent("update") : (this.stop(), this.dispatchEvent("finish"))))
        },
        dispatchEvent: function(b) {
            var c = a.Event(b + ".countdown");
            c.finalDate = this.finalDate, c.elapsed = this.elapsed, c.offset = a.extend({}, this.offset), c.strftime = d(this.offset), this.$el.trigger(c)
        }
    }), a.fn.countdown = function() {
        var b = Array.prototype.slice.call(arguments, 0);
        return this.each(function() {
            var c = a(this).data("countdown-instance");
            if (void 0 !== c) {
                var d = f[c],
                    e = b[0];
                j.prototype.hasOwnProperty(e) ? d[e].apply(d, b.slice(1)) : null === String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i) ? (d.setFinalDate.call(d, e), d.start()) : a.error("Method %s does not exist on jQuery.countdown".replace(/\%s/gi, e))
            } else new j(this, b[0], b[1])
        })
    }
});


/**
 * URL Query Strings
 **/
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


/**
 * Create the sales banner and starts the countdown timer.
 */
function squestial(endDate) {
  "use strict";
  window.$ = jQuery; //use jQuery

  //Add a div to put the sales banner
  let bannerHTML = '<div id="sale-banner"></div>';
  
  /* 
  	// Version with Miliseconds
  	let countdownHTML = '<div id="countdown"><div><div class="counter">%H</div> <div class="caption">Hrs</div></div> <span>:</span> <div><div class="counter">%M</div> <div class="caption">Min</div></div> <span>:</span> <div><div class="counter">%S</div> <div class="caption">Sec</div></div> <span>.</span> <div><div class="counter">%f</div> <div class="caption">Ms</div></div></div>';
   */
  
  let countdownHTML = '<div id="countdown"> <div><div class="counter">00</div> <div class="caption">Hrs</div></div> <span>:</span> <div><div class="counter">00</div> <div class="caption">Min</div></div> <span>:</span> <div><div class="counter">00</div> <div class="caption">Sec</div></div></div>';
  let buyButtonHTML = '<a class="buy-now-button" href="/collections/all">Buy Now</a>';

    //If URL is a product page, change the buy now button to add the product to the cart.
    if (window.location.href.indexOf("/collections/all/products") > -1) {
        buyButtonHTML = '<a class="buy-now-button" onclick="$(\'.add_to_cart\')[0].click()">Add to Cart</a>';
    }

    //Mobile Elements
    if ($(window).width() < 767) {
        /* OLD MOBILE AT HEADER */
// 		$(".mobile_logo").before('<div id="sale-title">' + saleTitle + '</div>'); //Sale Title Section
// 		$("#shopify-section-header").after('<div id="sale-timer"> X Days, 0 Hours, X Minutes Remaining</div>'); //Timer Section
//     	$("#shopify-section-header").css("margin-top", "40px");
//         $(".mobile_logo .logo a").css("margin-top", "0px");

      /*TIMER AT BOTTOM */
      $("body").addClass("bottom");

      /*TIMER AT TOP */
      //         $("body").addClass("top-mobile");
      $("body").prepend(bannerHTML);
      //   $(".nav-bar.sticky").after(bannerHTML);
      

        //For VIORI
        if ($(".mobile-nav-bar-wrapper").hasClass("sticky")){
            $(".mobile-nav-bar-wrapper").removeClass("sticky");
        }

        //For Ravean theme promo banner
        /*
          if ($.cookie('promo_banner') != 'dismiss' ) {
              //if ($("body").hasClass("promo_banner--true")){
              //if ($(".promo_banner_mobile").css("display") != "none"){
              $("#sale-banner").css("top", 60 + "px");
              //$(".index-sections").css("top", $(".promo_banner_mobile").height()+$("#shopify-section-header").height());
          }
          */

        $("#sale-banner").append('<div id="sale-timer">' + countdownHTML + '<div class="sales-description">' + saleMessage + '</div></div>'); //Timer Section
        $("#sale-banner").append('<div id="sale-title"><div class="coupon-code">' + saleTitle + '</div></div>'); //Sale Title Section
        //$("#sale-banner").append(buyButtonHTML);
        $(".index-sections").css("padding-top", "25px");

        $('.promo_banner .icon-close, .promo_banner_mobile .icon-close').on('click', function () {
            $("#sale-banner").css("top", 40 + "px");
        });


    } else {

        //Desktop Elements
        $("body").addClass("top");
      
      //Hide Announcement bar
       document.querySelector("#shopify-section-announcement").hidden = true;

        //Create Additional HTML Elements
        //$('.mm-fixed-top .container').before('<div id="sale-title">' + saleTitle + '</div>'); //Sale Title Section

        //TODO: This will have to be modified to get the first element in any page:
        $('body').prepend(bannerHTML); //Timer Section
        $('#sale-banner').append('<div id="sale-timer"><div class="sales-description">' + saleMessage + '</div>' + countdownHTML + '</div> <div id="sale-title"><div class="coupon-code">' + saleTitle + '</div></div>'); //Timer Section
        //$('#sale-title').append(buyButtonHTML); //Sale Title Section

        //Adjust the first section to not be covered:
        //$('.shopify-section:first-child').css("margin-top", $("#sale-banner").height());
    } //end if
  
      //Countdown Timer
    $("#countdown").countdown(endDate, function (event) {
        $(this).html(
            event.strftime('<!--<div><div class="counter">%D</div> <div class="caption">Days</div></div>--> <div><div class="counter">%H</div> <div class="caption">Hrs</div></div> <span>:</span> <div><div class="counter">%M</div> <div class="caption">Min</div></div> <span>:</span> <div><div class="counter">%S</div> <div class="caption">Sec</div></div>')
        );
    });
  } //squestial()


/*
  function unitsRemaining(){

    //Set Variables
    var unitName = "Jacket"; //Singluar Form
    var custName = [
      "Traci  B.",
      "Ryan B."];

    var custLoc = [
      "Sherwood, OR",
      "Salt Lake City, UT"
    ];
    
    //Units Remaining Section
    $('body').after('<div id="units-remaining"><strong>Only</strong><span class="number-remaining counter">X</span>' + unitName + 's left</div>');

    //Someone Bought Notification Section
    $('body').after('<div id="someone-bought"><strong><span id="someone">Someone</span> from <span id="somewhere">Somewhere</span></strong><br/><span>just bought a ' + unitName + '!</span></div>');

    //Hide the Nav Menu
//    $('ul.menu').hide();

    //Adjust the logo to be centered:
//       $(".header .container .four.columns").css("width", "initial");
// 	  $(".header .logo").css("position", "relative");
//       $(".header .logo").css("transform", "translate(-50%, 0%)");
//       $(".header .logo").css("left", "50%");

    //Set how many Units Remain
    var unitsRemaining = Cookies.get('unitsRemaining');

    //Sound Notification
    //	  var audio = new Audio('{{ 'microbounce.mp3' | asset_url }}');

    if (Cookies.get('unitsRemaining') == null) {
        unitsRemaining = Math.floor(Math.random() * 11) + 10; //Range of starting jackets
        Cookies.set('unitsRemaining', unitsRemaining);
    }

    $('.number-remaining').text(Cookies.get('unitsRemaining'));

    // var currentDate = new Date();
    // currentDate.setDate(currentDate.getDate() + 1);
    // Cookies.set('endSaleDate', (currentDate.getMonth() + 1) + "/" + currentDate.getDate() + "/" + currentDate.getFullYear());

    //var timer = setInterval(saleNotification, 3000);
    // 1000 = Initial timer when the page is first loaded

    //Random Time
    function randRange(data) {
        var newTime = data[Math.floor(data.length * Math.random())];
        return newTime;
    }
    */


    /** 
    * Fires off the sales notification popup 
    **/
/*
    function saleNotification() {
        var timeArray = new Array(20000, 45000, 60000); //Random array of seconds

        if (unitsRemaining > 3) {
            //change the units
            //unitsRemaining--;
            //Cookies.set('unitsRemaining', unitsRemaining);
            $('.number-remaining').text(unitsRemaining);

            audio.play();

            //change the name of the person buying
            var randNum = Math.floor((Math.random() * 19) + 0);
            $("#someone").text(custName[randNum]);
            $("#somewhere").text(custLoc[randNum]);

            $('#someone-bought').fadeIn(500, "swing", function () {
                $('#someone-bought').delay(3000).fadeOut(1500);
            });

        }

        clearInterval(timer);
        timer = setInterval(saleNotification, randRange(timeArray));
    } //saleNotification()
*/


  
    //VIORI Change
    // If they come in with the link, change to one-time purchase
    /*  setTimeout(
        function(){
              if ($("input[id^='rc_purchase_type_onetime']").length){
              $("input[id^='rc_purchase_type_onetime']").trigger("click");
           }
        }, 1500);    */
 

//Have a General option for anyone coming to the site for the first time without a special tag.
let source = (getParameterByName('src')==null) ? "" : getParameterByName('src'); //URL Param

//Check if any cookie exists and is active
//This is the priority order when the user has multiple cookie tags.
// if (new Date() < new Date(Cookies.get('remarket'))){
//     source = "bars-rmkt";
// } else if (new Date() < new Date(Cookies.get('bars-9'))){
//     source = "bars-9";
// } else if (new Date() < new Date(Cookies.get('bars-fpo'))){
//     source = "bars-fpo";
// } else if (new Date() < new Date(Cookies.get('bars-twpo'))){
//     source = "bars-twpo";
// } else if (new Date() < new Date(Cookies.get('bars-twfpo'))){
//     source = "bars-twfpo";
// } else if (new Date() < new Date(Cookies.get('bars-thpo'))){
//     source = "bars-thpo";
// }

//Use this if we just want to show the discount code according to the code which they clicked

//Logic to determine if we should show the special squeeze banner.
switch(source){

    /*If there is no cookie, set show this message for everyone as the default*/
    default:
//         /*disable for mobile devices only*/
//    		if (! /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {

        //         /** If it's the visitors first time, set cookie. **/
        //         if (Cookies.get('general') == null){
        //             Cookies.set('general', new Date((new Date()).valueOf() + 1000*3600*24).toISOString().substring(0, 10), {expires: 30});
        //         }

        /* SALES DATES VARIABLES */
    
        /* Change Sales Date Timers Here */
        let salesDate = new Date("April 1, 2023 6:00:00");
		
	    //Cookies.set('mother', new Date((new Date()).valueOf() + 1000*3600*24).toISOString().substring(0, 10), {expires: 30});
//        if (new Date() < salesDate) {		
//            saleTitle = '<a href="/collections/all">CODE = THXMOM20</a>';
//          saleMessage = "<strong> 20% OFF MOTHER'S DAY SALE LIMITED TIME ONLY </strong>";
//         squestial(salesDate.toLocaleDateString('en-US'));
//        }

//         /*check to see if they have visited this link before and the sale timer hasn't ended.*/
//         if (new Date() < new Date(salesDate1)) { //Pre-Black Friday
//             salesDate = new Date(salesDate1);
//             saleTitle = "Limited Time";
//             saleMessage = "<strong>15% Off Christmas Countdown Sale</strong>";
// //         } else if (new Date() < new Date("11/26/2018 6:59:00 AM UTC")) { //Black Friday
// // 	        salesDate = new Date("11/26/2018 6:59:00 AM UTC");
// //           	saleTitle = "code = BF20%";
// //     	    saleMessage = "<strong>Black Friday Sale!</strong> Use code for 20% Off!";

// //         } else if (new Date() < new Date("12/1/2018 6:59:00 AM UTC")) { //Cyber Monday
// //         	salesDate = new Date("12/1/2018 6:59:00 AM UTC");
// //             saleTitle = "code = CYBER20%";
// // 	        saleMessage = "<strong>Cyber Week Sale!</strong> Use code for 20% Off!";

// //        } else { //Everyone Else
           saleTitle = '<a href="/collections/all">Buy Now</a>';
 	        saleMessage = "Last Chance to get Purple Lavendar Bars!";
//         }
        squestial(salesDate.toLocaleDateString('en-US'));
//		} //end mobile if
       break;



    //If the user came under this tag, set the following values per code
    case "bars-9":

        //If it's the visitors first time, set the cookie and date.
        if (Cookies.get('bars-9') == null){
            Cookies.set('bars-9', new Date((new Date()).valueOf() + 1000*3600*24).toISOString().substring(0, 10), {expires: 30});
        }

        //Check to see if they have visited this link before and the sale timer hasn't ended.
        if (new Date() < new Date(Cookies.get('bars-9'))) {
            saleTitle = "";
            saleMessage = "Order Today Receive in Time for Christmas";
            squestial(Cookies.get('bars-9'));
        }
        break;


    case "bars-fpo":

        if (Cookies.get('bars-fpo') == null){ //If it's the visitors first time, set the cookie and date.

            Cookies.set('bars-fpo', new Date((new Date()).valueOf() + 1000*3600*24).toISOString().substring(0, 10), {expires: 30});
        }
        //check to see if they have visited this link before and the sale timer hasn't ended.
        if (new Date() < new Date(Cookies.get('bars-fpo'))) {
            saleTitle = "";
            saleMessage = "Order Today Receive in Time for Christmas";
            squestial(Cookies.get('bars-fpo'));
        }
        break;


    case "bars-twpo":

        //If it's the visitors first time, set cookie as a date of when the promo expires.
        if (Cookies.get('bars-twpo') == null){
            Cookies.set('bars-twpo', new Date((new Date()).valueOf() + 1000*3600*24).toISOString().substring(0, 10), {expires: 30});
        }

        //check to see if they have visited this link before and the sale timer hasn't ended.
        if (new Date() < new Date(Cookies.get('bars-twpo'))) {

            // Set the Sales Title
            saleTitle = "";

            // Set the Sales Message
            saleMessage = "Order Today Receive in Time for Christmas";

            //Fire the function with the date as the argument
            squestial(Cookies.get('bars-twpo'));
        } //end if
        break;


    case "bars-twfpo":
        if (Cookies.get('bars-twfpo') == null){
            Cookies.set('bars-twfpo', new Date((new Date()).valueOf() + 1000*3600*24).toISOString().substring(0, 10), {expires: 30});
        }
        if (new Date() < new Date(Cookies.get('bars-twfpo'))) {
            saleMessage = "<strong>Limited Time Only:</strong> Use Discount Code to Get 25% Off Your Purchase";
            saleTitle = "CODE = V25OFF%";
            squestial(Cookies.get('bars-twfpo'));
        }
        break;


    case "bars-thpo":
        if (Cookies.get('bars-thpo') == null){
            Cookies.set('bars-thpo', new Date((new Date()).valueOf() + 1000*3600*24).toISOString().substring(0, 10), {expires: 30});
        }
        //check to see if they have visited this link before and the sale timer hasn't ended.
        if (new Date() < new Date(Cookies.get('bars-thpo'))) {
            saleMessage = "<strong>Limited Time Only:</strong> Use Discount Code to Get 30% on Your Purchase";
            saleTitle = "CODE = VIORI30%";
            squestial(Cookies.get('bars-thpo'));
        }
        break;

}